export default "__VITE_ASSET__cc793a7d__"